// import Seo from "../../components/Seo/Seo";
import Wrapper from "../../layout/wrapper/Wrapper";
import { Box } from "@mui/material";
import React from "react";
import styles from "../../styles/pages/myaccount.module.scss";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import UserCreateTab from "../../components/UserCreateTab/UserCreateTab";

const Myaccount = () => {
  return (
    <Wrapper>
      {/* <Seo
        title="My Account"
        canonical={""}
        description={""}
        url={""}
        image={""}
      /> */}
      <Box className="main_body">
        <Box className={`commonBox ${styles.pageMyAccountWrapper}`}>
          <Box className={styles.accountTab}>
            {/* <PerfectScrollbar> */}
            <UserCreateTab forgotText={"myaccount"} accountSubmission={false} />
            {/* </PerfectScrollbar> */}
          </Box>
        </Box>
      </Box>
    </Wrapper>
  );
};

export default Myaccount;
